<template>
  <div class="AboutStat text-center">
    <div class="AboutStat__icon border-b-4 border-dark-red text-5xl">
      <i
        :class="icon"
        class="mps"
      />
    </div>
    <div class="AboutStat__number font-extrabold my-2 text-2xl">
      {{ number }}
    </div>
    <div class="AboutStat__text font-bold uppercase text-lg">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutStat',
  props: {
    icon: {
      type: String,
      default: ''
    },
    number: {
      type: Number,
      default: 0
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

</style>
